import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import {Link as RouterLink} from 'react-router-dom'

const useStyles = makeStyles(theme => ({
	root: {
		paddingTop: theme.spacing(8),
		textAlign: 'center',
	},
	code: {
		fontSize: '2.4rem',
		fontWeight: 700,
		color: theme.palette.text.secondary,
	},
	title: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(1),
		fontWeight: 600,
	},
	subtitle: {
		marginBottom: theme.spacing(3),
		color: theme.palette.text.secondary,
	},
}))

function NotFound() {
	const classes = useStyles()

	return (
		<Container className={classes.root} maxWidth="md">
			<div className={classes.code}>404</div>
			<Typography variant="h5" className={classes.title} component="h1">
				Page not found
			</Typography>
			<Typography variant="body1" className={classes.subtitle}>
				The page you&apos;re looking for doesn&apos;t exist or has been
				moved.
			</Typography>
			<div style={{display: 'inline-block'}}>
				<Button className="new-button" component={RouterLink} to="/">
					Go to Home
				</Button>
			</div>
		</Container>
	)
}

export default NotFound
